import React, { useState, useEffect, useRef, useImperativeHandle, forwardRef,  } from 'react';
import { Modal } from 'antd';
import {ajax, unparam } from 'utils/common';
import VideoPlayer from "components/videoPlayer";
import VideoPage from "../common/video";

import userReport from "../../../images/aiReport/user-report.png";

const ResultApp = forwardRef((props, ref) => {
    const {
        closeAudio,
        data = {},
        userInfo = {},
    } = props;
    const videoPlayer = useRef(null);
    const queryString = unparam(location.search);
    const [visible, setVisible] = useState(false);

    useImperativeHandle(ref, () => (
        {
            closeVideo: ()=> {
                let limbVideo = document.getElementById('limbVideo');
                limbVideo.pause();
            }
        }
    ), []);

    const pauseAll = (index, videos) => {
        for (let j = videos.length - 1; j >= 0; j--) {
            if (j!=index) {
                videos[j].pause();
            }
        }
    };

    const onOpenVideo = () => {
        setVisible(true);
    };

    const renderImg = (url) => {
        if(url){
            return (
                <div className='limb-result-img-wrap'>
                    <img src={url} className='limb-result-img'/>
                </div>
            )
        }
        return <div className='limb-result-img-wrap limb-result-img-no'><span>未完成动作</span></div>
    };

    const renderLimbData = (param) => {
        return (
            <div className='limb-result-cont'>
                <span className='limb-result-cont-tip'>{param.type}识别结果</span>
                <span>手指灵活度：<i className={param.flexibility.status == 0 ? 'yes' : ''}>{param.flexibility.desc || ''}</i></span>
                <span>手指完整度：<i className={param.integrity.status == 0 ? 'yes' : ''}>{param.integrity.desc || ''}</i></span>
                <span>手部纹身：<i className={param.tattooing.status == 0 ? 'yes' : ''}>{param.tattooing.desc || ''}</i></span>
            </div>
        )
    };

    const renderResult = (type, item) => {
        return (
            <div className='limb-result'>
                {renderImg(item.handFrontUrl || '')}
                {renderImg(item.handFistUrl || '')}
                {renderImg(item.handBackUrl || '')}
                {renderLimbData({
                    type: type === 'left' ? '左手' : '右手', 
                    flexibility: item.fingerFlexibility || {}, 
                    integrity: item.fingerIntegrity || {}, 
                    tattooing: item.tattoo || {},
                })}
            </div>
        );
    };

    if(!data.result){
        return null;
    }

    return (
        <div className={`limb-record-wrap ${data.lastView ? 'limb-record-wrap-last' : ''}`}>
            <div className="readingTitleWrap">
                <div className="readingTitleLeft">
                    <div className="readingTitleLeftIcon">
                        <span></span>
                        <span></span>
                    </div>
                    <span className='lime-tota-title'>手部综合检测：</span>
                    <div className={`lime-total-eveal ${data.result && data.result.status == 0 ? '' : 'no'}`}>
                        {data.result && data.result.desc}
                        {/* {data.tattoo && data.tattoo.status == 1 ? '·' + data.tattoo.desc : ''} */}
                    </div>
                    {data.videoURL && <div className='lime-total-video' onClick={onOpenVideo}>点击查看视频</div>}
                </div>
            </div>
            {/*内容部分*/}
            <div className="result-padding">
                {renderResult('left', data.leftHand || {})}
                {renderResult('right', data.rightHand || {})}
            </div>
            <Modal
                className='limb-modal'
                visible={visible}
                width={750}
                centered
                mask={true}
                footer={null}
                onCancel={() => {
                    setVisible(false);
                    let limbVideo = document.getElementById('limbVideo');
                    limbVideo.pause();
                }}
            >
                <div className={`otherVideo`}>
                    <VideoPage
                        id="limbVideo"
                        isPlaybackRate={true}
                        poster={data.facePicPath || userInfo.facePicPath || userReport}
                        changeVideo={()=>{
                            closeAudio && closeAudio();
                        }}
                        videoUrl={`/oivi/api/file/review/${data.videoURL}`}
                        playNoVideo={() => {
                            closeAudio && closeAudio();
                        }}
                    />
                </div>
            </Modal>
        </div>
    );
})

export default ResultApp;
